// Generate unique device ID, store in localStorage
export const getDeviceId = () => {
  let deviceId = localStorage.getItem('vk_device_id');
  if (!deviceId) {
    deviceId = 'dev_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem('vk_device_id', deviceId);
  }
  return deviceId;
};

export const getDeviceName = () => {
  const ua = navigator.userAgent;
  const platform = navigator.platform || '';
  
  if (/Android/i.test(ua)) return 'Android ' + (ua.match(/Android ([0-9.]+)/)?.[1] || '');
  if (/iPhone|iPad/i.test(ua)) return 'iOS Device';
  if (/Windows/i.test(platform)) return 'Windows Browser';
  if (/Mac/i.test(platform)) return 'Mac Browser';
  if (/Linux/i.test(platform)) return 'Linux Browser';
  return 'Unknown Device';
};

export const getPlatform = () => {
  const ua = navigator.userAgent;
  if (/Android/i.test(ua)) return 'android';
  if (/iPhone|iPad/i.test(ua)) return 'ios';
  return 'web';
};

export const registerDevice = async (apiUrl, token) => {
  try {
    await fetch(`${apiUrl}/api/devices/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        device_id: getDeviceId(),
        device_name: getDeviceName(),
        platform: getPlatform()
      })
    });
  } catch (e) {
    console.warn('Device registration failed:', e.message);
    // Silent fail - không block user
  }
};
